import { useTranslation } from 'react-i18next';

import { PaymentLoadingOverlay } from '../common';

export const LoadingStep = () => {
	const { t } = useTranslation('openBanking');

	return <PaymentLoadingOverlay text={t('loader')} />;
};
